// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { AccountWorkflowBlock, AccountWorkflowSection } from '../../types';

export const COMBINED_ACCOUNT_OPENING_SECTIONS = [
  'personal-data',
  'professional-profile',
  'wealth-source-funds',
  'account-usage',
  'legal-declarations',
  'identity-verification',
  'signature',
] as const satisfies readonly AccountWorkflowSection[];

export const COMBINED_PROFILING_SECTIONS = [
  'contract-review',
  'investment-objectives',
  'financial-knowledge',
  'investment-experience',
  'financial-situation',
  'sustainability',
  'result-and-signature',
] as const satisfies readonly AccountWorkflowSection[];

export const getAccountOpeningBlocks = (options?: {
  includeNextSteps?: boolean;
}): AccountWorkflowBlock[] => {
  const blocks: AccountWorkflowBlock[] = COMBINED_ACCOUNT_OPENING_SECTIONS.map(
    section => ({
      id: section,
      label: `account-opening.steps.${section}`,
      completed: false,
    }),
  );

  if (options?.includeNextSteps) {
    blocks.push({
      id: 'next-steps',
      label: 'account-opening.steps.next-steps',
      completed: false,
    });
  }

  return blocks;
};

export const getCombinedProfilingBlocks = (): AccountWorkflowBlock[] =>
  COMBINED_PROFILING_SECTIONS.map(section => ({
    id: section,
    label: [`onboarding-blocks.${section}`, { ns: 'components' }],
    completed: false,
  }));
